import { DomainView } from "@/components/domain";
import { useSheetContext } from "@/context/sheet";
import { useDeleteDepartment, useGetDepartment } from "@/hooks/departments";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Key } from "react";

export const Route = createFileRoute("/(departments)/departments/_sheet/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data, isLoading } = useGetDepartment(id);
  const { close } = useSheetContext();
  const navigate = useNavigate();
  const { mutate: deleteDepartment } = useDeleteDepartment({
    onSuccess: () => {
      close(() => {
        navigate({ to: "/departments" });
      });
    },
  });

  return (
    <DomainView
      domain="departments"
      editLink={(children, key) => (
        <Link to="/departments/$id/edit" params={{ id }} key={key as Key}>
          {children}
        </Link>
      )}
      isLoading={isLoading}
      title={data?.name}
      onDelete={() => deleteDepartment(id)}
      propsList={[
        {
          title: "departments.fields.description",
          value: data?.description ?? "-",
        },
      ]}
    />
  );
}
